// API
import api from '../../api'

// Constants
import { inputBehaviorTypes } from '../../constants'

// Utilities
import Logger from '../../utility/loggerUtil'
import isEmpty from '../../utility/isEmpty'

export default {
  async updateFieldTracking (context, data) {
    try {
      context.commit('updateFieldTracking', {
        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,
        cellPhoneNumber: data.cellPhoneNumber,
        email: data.email,
        dateOfBirth: data.dateOfBirth,
        address: data.address,
        mailingAddress: data.mailingAddress,
        zip: data.zip,
        mailingZip: data.mailingZip,
        idNumber: data.idNumber,
        idExpiration: data.idExpiration,
        tin: data.tin,
        incomeName: data.incomeName,
        routingNum: data.routingNum,
        accountNum: data.accountNum
      })

      if (isEmpty(context.rootState.applicationCustomer.applicationId)) {
        return
      }

      if (isEmpty(data)) {
        data = fieldTrackingData(context)
      }

      await api.applicationFieldTracking.updateFieldTracking(
        context.rootState.applicationCustomer.applicationId,
        data.firstName,
        data.middleName,
        data.lastName,
        data.cellPhoneNumber,
        data.email,
        data.dateOfBirth,
        data.address,
        data.mailingAddress,
        data.zip,
        data.mailingZip,
        data.idNumber,
        data.idExpiration,
        data.tin,
        data.incomeName,
        data.routingNum,
        data.accountNum
      )
    } catch (error) {
      // do not throw an error
      Logger.error('Error on fieldTracking/updateFieldTracking')
      Logger.debug(error)
    }
  },

  async setDefaultFieldTrackingReturnUser (context, data) {
    try {
      context.commit('updateFieldTracking', {
        firstName: defaultPrefill(data.firstName),
        middleName: defaultPrefill(data.middleName),
        lastName: defaultPrefill(data.lastName),
        cellPhoneNumber: defaultPrefill(data.cellPhoneNumber),
        email: defaultPrefill(data.email),
        dateOfBirth: defaultPrefill(data.dateOfBirth),
        address: defaultPrefill(data.address),
        mailingAddress: defaultPrefill(data.mailingAddress),
        zip: defaultPrefill(data.zip),
        mailingZip: defaultPrefill(data.mailingZip),
        idNumber: defaultPrefill(data.idNumber),
        idExpiration: defaultPrefill(data.idExpiration),
        tin: defaultPrefill(data.tin),
        incomeName: defaultPrefill(data.incomeList?.[0]?.incomeName),
        routingNum: defaultPrefill(data.routingNum),
        accountNum: defaultPrefill(data.accountNum)
      })

      await api.applicationFieldTracking.updateFieldTracking(
        context.rootState.applicationCustomer.applicationId,
        context.state.firstName,
        context.state.middleName,
        context.state.lastName,
        context.state.cellPhoneNumber,
        context.state.email,
        context.state.dateOfBirth,
        context.state.address,
        context.state.mailingAddress,
        context.state.zip,
        context.state.mailingZip,
        context.state.idNumber,
        context.state.idExpiration,
        context.state.tin,
        context.state.incomeName,
        context.state.routingNum,
        context.state.accountNum
      )
    } catch (error) {
      // do not throw an error
      Logger.error('Error on fieldTracking/setDefaultFieldTrackingReturnUser')
      Logger.debug(error)
    }
  }
}

const fieldTrackingData = (context) => {
  return {
    firstName: context.state.firstName || undefined,
    middleName: context.state.middleName || undefined,
    lastName: context.state.lastName || undefined,
    cellPhoneNumber: context.state.cellPhoneNumber || undefined,
    email: context.state.email || undefined,
    dateOfBirth: context.state.dateOfBirth || undefined,
    address: context.state.address || undefined,
    mailingAddress: context.state.mailingAddress || undefined,
    zip: context.state.zip || undefined,
    mailingZip: context.state.mailingZip || undefined,
    idNumber: context.state.idNumber || undefined,
    idExpiration: context.state.idExpiration || undefined,
    tin: context.state.tin || undefined,
    incomeName: context.state.incomeName || undefined,
    routingNum: context.state.routingNum || undefined,
    accountNum: context.state.accountNum || undefined
  }
}

const defaultPrefill = (value) => {
  return isEmpty(value) ? undefined : inputBehaviorTypes.prefilled
}
